var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgElevation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.275,
    height: 11.389,
    viewBox: "0 0 18.275 11.389",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elevation",
    transform: "translate(0.903 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3497",
    "data-name": "Trac\\xE9 3497",
    d: "M25.444,8.111a.569.569,0,1,0,.805-.805L25.111,6.167a.569.569,0,0,0-.805,0L23.167,7.305a.569.569,0,0,0,.805.805l.167-.167v7.5l-.167-.167a.569.569,0,0,0-.805.805l1.139,1.139a.569.569,0,0,0,.805,0l1.139-1.139a.569.569,0,0,0-.805-.805l-.167.167v-7.5Z",
    transform: "translate(-9.044)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3499",
    "data-name": "Trac\\xE9 3499",
    d: "M9.275,19.785,7.463,17.271a.7.7,0,0,0-1.107,0L2,23.313H6.716Z",
    transform: "translate(-2.903 -5.924)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3500",
    "data-name": "Trac\\xE9 3500",
    d: "M10,23.313l4.355-6.042a.7.7,0,0,1,1.107,0l4.355,6.042Z",
    transform: "translate(-5.293 -5.924)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevation);
export default __webpack_public_path__ + "static/media/elevation.d2d675f3aa2464d8fd4cb623fe58af3f.svg";
export { ForwardRef as ReactComponent };